import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
export const withPresetIconProps = (Component)=>(props)=>{
        return /*#__PURE__*/ React.createElement(Component, _extends({}, props, {
            size: IconSize.MEDIUM,
            disableDefaultColors: true
        }));
    };
